export default __webpack_public_path__ + "static/media/bg1.f041ac17.png";